import { useMutation } from '@tanstack/react-query';
import { message } from 'antd';
import { api } from '../../@common';

export const useForgotPassword = () => {
  const forgotPassword = useMutation({
    mutationFn: async (email: string) => {
      return await api.post('/auth/forgot-password', { email });
    },
    onSuccess: () => {
      message.success('Se o email existir, você receberá as instruções para substituir sua senha', 5);
    },
    onError: () => {
      message.error('Erro ao solicitar redefinição de senha');
    },
  });

  return {
    forgotPassword,
    isLoading: forgotPassword.isPending,
    isSuccess: forgotPassword.isSuccess,
  };
};
